import { render, staticRenderFns } from "./ContentTemplateThumbnail.vue?vue&type=template&id=452a9014&scoped=true&"
import script from "./ContentTemplateThumbnail.vue?vue&type=script&lang=js&"
export * from "./ContentTemplateThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452a9014",
  null
  
)

export default component.exports